// extracted by mini-css-extract-plugin
export var gif = "_ju-0";